import { Component, Input, ViewEncapsulation } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { GridContext, GenericColDef } from '../../../models/grid-context';

export interface DragCellParams extends ICellRendererParams {
    dragScope: string[];
    checkable: boolean;
    inputDisabled: boolean;
    inlineEdit: (params) => boolean;
    onInlineEdit?: (string) => void;
    required: (params) => boolean;
    setDraggedItem: (params) => void;
    onDragCanceled: () => void;
}

@Component({
    standalone: false,
    templateUrl: './drag-cell.component.html',
    styleUrls: ['./drag-cell.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class DragCellComponent implements ICellRendererAngularComp {
    params: DragCellParams;
    gridContext: GridContext;
    colDef: GenericColDef;
    automationId: string;
    tooltip: string;
    @Input() isDisabled: boolean;

    agInit(params: DragCellParams): void {
        this.params = params;
        this.gridContext = this.params.context as GridContext;
        this.colDef = this.params.column.getColDef() as GenericColDef;
        this.tooltip = (params.data && (params.data?.metadataTooltip || params.data?.tooltip)) ? (params.data?.metadataTooltip || params.data?.tooltip) : params?.value;
        this.automationId = `${(this.colDef && this.colDef.automationId) ? this.colDef.automationId + '-' : ''}list-item`;
    }


    onChange(): void {
        if (this.params.onInlineEdit) {
            this.params.onInlineEdit(this.params.data.externalName);
        }
    }

    refresh(): boolean {
        return false;
    }
}
